import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import AccountStore from "./modules/main/store/account/account-store";
import ActivityCenterStore from "./modules/sidebar/activity-center/store/activity-center-store";
import AgentStore from "./modules/agents/store/agent-store";
import ApplicationStore from "./modules/clients/applications/application/store";
import ApplicationsListStore from "./modules/clients/applications/application/applications-list/store/applications-list-store";
import AutomationStore from "./modules/automation/automation/store/automation-store";
import BoardStore from "./modules/clients/board/store/board-store";
import MarketingStore from "./modules/marketing/store/marketing/marketing-store";
import TemplatesStore from "./modules/marketing/store/templates/templates-store";
import ReferrerStore from "./modules/clients/referrers/store/referrer-store";
import DocumentsStore from "./modules/clients/applications/documents/store/documents-store";
import RouterStore from "./routes/store";
import SettingsStore from "./modules/settings/store/settings-store";
import DisclaimersStore from "./modules/settings/disclaimers/store/disclaimers-store";
import DripCampaignStore from "./modules/automation/drip-campaign/store/drip-campaign-store";
import DashboardStore from "./modules/dashboard/store/dashboard-store";
import StatusPageStore from "./modules/status-page/store/status-page-store";
import AccountPlanStore from "./modules/account-plan/store/account-plan-store";
import BrowserPreferencesStore from "./modules/browser-preferences/store/browser-preferences-store";
import ReportsStore from "./modules/clients/reports/store/reports-store";
import WebsocketStore from "./modules/websocket/store/websocket-store";
import FinancialToolsStore from "./modules/financial-tools/store/financial-tools-store";
import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
import createMutationsSharer from "vuex-shared-mutations";
import Amplitude from "@Shared/@Utils/amplitude";
import { cloneDeep, forOwn, pickBy } from "lodash";
import createCache from "vuex-cache";
Vue.use(Vuex);
Vue.config.devtools = process.env.ENVIRONMENT === "test";
const vuexPersist = new VuexPersist({
  strictMode: process.env.ENVIRONMENT === "test",
  key: "broker-portal",
  storage: window.localStorage,
  modules: ["AccountStore", "BrowserPreferencesStore"]
});
const modules = {
  AgentStore,
  BoardStore,
  ApplicationStore,
  AutomationStore,
  MarketingStore,
  TemplatesStore,
  AccountStore,
  ActivityCenterStore,
  ApplicationsListStore,
  ReferrerStore,
  DocumentsStore,
  RouterStore,
  SettingsStore,
  DisclaimersStore,
  DripCampaignStore,
  DashboardStore,
  StatusPageStore,
  AccountPlanStore,
  BrowserPreferencesStore,
  ReportsStore,
  WebsocketStore,
  FinancialToolsStore
};
Vue.store = new Vuex.Store({
  strict: process.env.ENVIRONMENT === "test",
  state: {},
  mutations: {
    RESTORE_MUTATION: vuexPersist.RESTORE_MUTATION,
    resetState(state) {
      forOwn({
        AccountStore
      }, (value, key) => {
        state[key] = cloneDeep(value.state);
      });
    },
    clearState(state) {
      const storesExcludedFromClear = ["RouterStore", "BrowserPreferencesStore"];
      const stores = pickBy(modules, (value, key) => !_includesInstanceProperty(storesExcludedFromClear).call(storesExcludedFromClear, key));
      forOwn(stores, (value, key) => {
        state[key] = cloneDeep(value.state);
      });
    }
  },
  actions: {},
  modules,
  plugins: [vuexPersist.plugin, createMutationsSharer({
    predicate: ["resetState", "clearState", "AccountStore/SET_SESSION_DETAILS"]
  }), createCache()]
});
Vue.store.subscribeAction({
  error: (action, state, error) => {
    Amplitude.logVuexActionError(error, action);
  }
});
export default Vue.store;